import { type ComponentType } from 'react';
import { CustomerAutocomplete as UntypedCustomerAutocomplete } from '../../components/CustomerAutocomplete';
import { type CustomerChoice } from './portalUser';

type PickerProps = {
  value: CustomerChoice | null;
  onChangeValue: (customer: CustomerChoice | null) => void;
  label?: string;
  className?: string;
};

/* The picker is JavaScript whose props TypeScript infers as all required; this names the ones the Admin pages pass. */
export const CustomerPicker = UntypedCustomerAutocomplete as ComponentType<PickerProps>;
